import React from "react";
import {  useSelector } from "react-redux";
import { Button, Col, Popconfirm, Row, Timeline, Collapse } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  CaretRightOutlined,
} from "@ant-design/icons";
import { INFO_ELIMINAR } from "../../../utils";

// import {
//   loadRecordExpLaboral,
//   removeExpLaboral,
// } from "../../../redux/aspirante/aspiranteDucks";

const { Panel } = Collapse;

// function callback(key) {
//   console.log(key);
// }

/**
 * Componente para mostrar el Timeline de la experiencia laboral del aspirante
 * @returns JSX
 */
export const Historial = ({ showModal, form, setActFechaFin }) => {
  // const dispatch = useDispatch();
  const { listadoExperiencia } = useSelector(
    (state) => state.aspirante.aspirante
  );

  const { areasExperiencia, remuneraciones } = useSelector(
    (state) => state.catalogos
  );

  /**
   * Función para obtener la descripción de una area de experiencia
   * @param {string} idArea
   */
  function obtenerDescExperiencia(idArea) {
    if (areasExperiencia !== undefined) {
      const resultado = areasExperiencia.find(
        (item) => item.areaId + "" === idArea
      );
      return resultado !== undefined ? resultado.nombre : "";
    } else {
      return "";
    }
  }

  /**
   * Función para obtener la descripción de una remuneración
   * @param {string} idRemuneracion
   */
  function obtenerDescRemuneracion(idRemuneracion) {
    if (remuneraciones !== undefined) {
      const resultado = remuneraciones.find(
        (item) => item.remuneracionId + "" === idRemuneracion
      );
      return resultado !== undefined ? resultado.remuneracion : "";
    } else {
      return "";
    }
  }

  /**
   * Función que elimina un registro de la lista
   * @param {number} id
   */
  const eliminarRegistroExpLaboral = (id) => {
    // dispatch(removeExpLaboral(id));
  };

  /**
   * Función que manda los valores al formulario del modal para su respectiva edición
   * @param {object} registro object del formulario del modal
   */
  const editarExpLaboral = (registro) => {
    // dispatch(loadRecordExpLaboral(registro));
    let valorActual;
    Object.entries(registro).forEach(([key, value]) => {
      form.setFieldsValue({ [key]: value });
      if (key === "actual") {
        valorActual = value;
      }
    });
    showModal();
    setActFechaFin(valorActual === 1 ? true : false);
  };

  const MostrarDetalleExperiencia = ({ item }) => (
    <Timeline.Item key={item.id}>
      <Row>
        <Col span={20}>
          <div className="titulo-academico">{item.cargo}</div>
        </Col>
        <Col span={1}>
          <Button
            id="bntCircle"
            shape="circle"
            icon={<EditOutlined />}
            onClick={() => editarExpLaboral(item)}
          />
        </Col>
        <Col span={1}>
          <Popconfirm
            title={INFO_ELIMINAR}
            onConfirm={() => eliminarRegistroExpLaboral(item.id)}
            okText="Aceptar"
            cancelText="Cancelar"
          >
            <Button id="bntCircle" shape="circle" icon={<DeleteOutlined />} />
          </Popconfirm>
        </Col>
      </Row>
      <Row style={{ marginTop: 5 }}>
        <Col span={16}>
          <p>
            {" "}
            <label
              style={{ color: "gray", fontWeight: "normal", fontSize: "18px" }}
            >
              {item.fhini == null
                ? "N/A"
                : new Date(item.fhini).toLocaleDateString("es-MX")}
              {" - "}
              {item.fhfin == null
                ? "actual"
                : new Date(item.fhfin).toLocaleDateString("es-MX")}
            </label>
          </p>

          <p>
            {" "}
            Área: {obtenerDescExperiencia(item.area)}
            <br />
            Empresa: {item.empresa}
          </p>

          <p> Remuneracion: {obtenerDescRemuneracion(item.remuneracion)}</p>

          <Collapse
            ghost
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Panel
               header={
                <div className="sub-titulo-academico">
                  <div style={{ textDecoration: "underline" }}>
                    Funciones: <span>Ver detalle...</span>
                  </div>
                </div>
              }
              key={item.id}
            >
              <div
                style={{
                  color: "gray",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {item.funciones}
              </div>
            </Panel>
          </Collapse>
        </Col>
      </Row>
    </Timeline.Item>
  );

  return (
    <div>
      <Timeline id="timeLine" style={{ marginTop: 10 }}>
        {
          //store.getState().aspirante.aspiranteExpLa.listadoExperiencia !== undefined
          listadoExperiencia !== undefined &&
            listadoExperiencia.map((item) => (
              <MostrarDetalleExperiencia item={item} />
            ))
        }
      </Timeline>
    </div>
  );
};
